export const USER_DETAILS_QUERY_KEY = ["user-details"] as const;
